import { render } from "./ShipmentPackageBatchContent.vue?vue&type=template&id=3fec2c00&scoped=true"
import script from "./ShipmentPackageBatchContent.vue?vue&type=script&lang=js"
export * from "./ShipmentPackageBatchContent.vue?vue&type=script&lang=js"

import "./ShipmentPackageBatchContent.vue?vue&type=style&index=0&id=3fec2c00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fec2c00"]])

export default __exports__